import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const textareaResponsive = media.tablet`
    background-color: #fff;
`;

const textareaMobile = media.phone`
    min-height: 120px;
    background-color: #f5f7fa;
`;

const copyEmbedCodeButtonMobile = media.phone`
    margin: 0 auto;
`;

export const Wrapper = styled.div`
  textarea {
    line-height: 20px;
    padding: 10px 12px;
    min-height: 100px;
    margin: 7px 0 20px 0;
    ${textareaResponsive};
    ${textareaMobile};
  }
  button {
    min-width: 170px;
    max-width: initial;
    ${copyEmbedCodeButtonMobile};
  }
`;
